/* tslint:disable */
// @ts-nocheck
import React from 'react'
import { formValues } from 'redux-form'
import DateRangeInputContainer from '../../../components/FormBuilder/DateRangeInput/DateRangeInputContainer'

const DateRangeContainer = ({
  dateFrom,
  dateTo,
  _reduxForm,
  children,
  containerStyles,
  onChange,

  ...rest
}) => {
  const changeField = (fieldName: string) => (date: Date) =>
    _reduxForm.dispatch(_reduxForm.change(fieldName, date))

  const changeFrom = (date: Date) => {
    if (onChange) {
      onChange('dateFrom', date)
    }

    changeField('dateFrom')(date)
  }

  const changeTo = (date: Date) => {
    if (onChange) {
      onChange('dateTo', date)
    }
    changeField('dateTo')(date)
  }

  return (
    <DateRangeInputContainer
      {...rest}
      dateFrom={dateFrom}
      dateTo={dateTo}
      changeDateFrom={changeFrom}
      changeDateTo={changeTo}
      containerStyles={{ zIndex: 1299, ...containerStyles }}
    >
      {children}
    </DateRangeInputContainer>
  )
}

const DateRangeContainerWithDateFields = formValues<any>({
  dateFrom: 'dateFrom',
  dateTo: 'dateTo',
})(DateRangeContainer)

export default DateRangeContainerWithDateFields
